import { EVENTBRITE_URL } from "@/lib/data";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[color:var(--line-strong)] bg-[color:var(--bone)] pt-10 md:pt-14 pb-20 md:pb-10"
    >
      <div className="mx-auto max-w-[1360px] px-5 md:px-8">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-2">
              <span className="font-serif text-[26px] leading-none italic font-medium">
                Packt
              </span>
              <span className="h-4 w-px bg-[color:var(--line-strong)]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[color:var(--ink-3)]">
                Certification
              </span>
            </div>
            <p className="mt-4 max-w-[520px] text-[14px] leading-[1.6] text-[color:var(--ink-2)]">
              A live, practical certification for finance professionals building
              agentic AI systems. Instructed by Nicole Königstein.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[color:var(--ink-3)]">
              Explore
            </p>
            <ul className="mt-3 space-y-2 text-[14px]">
              <li><a href="#program" className="hover:text-[color:var(--copper)]">Program</a></li>
              <li><a href="#curriculum" className="hover:text-[color:var(--copper)]">Curriculum</a></li>
              <li><a href="#instructor" className="hover:text-[color:var(--copper)]">Instructor</a></li>
              <li><a href="#pricing" className="hover:text-[color:var(--copper)]">Pricing</a></li>
              <li><a href="#faq" className="hover:text-[color:var(--copper)]">FAQ</a></li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[color:var(--ink-3)]">
              Enroll
            </p>
            <ul className="mt-3 space-y-2 text-[14px]">
              <li>
                <a
                  href={EVENTBRITE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[color:var(--copper)]"
                >
                  Eventbrite ↗
                </a>
              </li>
              <li>
                <a
                  href="mailto:bootcamps@packt.com"
                  className="hover:text-[color:var(--copper-2)]"
                >
                  bootcamps@packt.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-6 border-t border-[color:var(--line)] flex flex-col md:flex-row md:items-center justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.2em] text-[color:var(--ink-3)]">
          <span>© {year} Packt Publishing Limited</span>
          <span>Prices in USD · Eventbrite fees may apply</span>
        </div>
      </div>
    </footer>
  );
}
